import { Link } from "react-router-dom";
import { ShieldCheck, FileClock } from "lucide-react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { TERMS_PAGE } from "@/constants/testIds";
import { Footer } from "@/components/Footer";
import { TERMS_CONTENT, TERMS_PUBLISHED } from "@/content/legalContent";

export default function Terms() {
  return (
    <div className="min-h-screen bg-background">
      <header className="flex items-center justify-between px-6 md:px-12 py-6">
        <Link to="/" className="flex items-center gap-2">
          <ShieldCheck className="w-7 h-7 text-petroleum" strokeWidth={1.5} />
          <span className="font-heading text-xl font-bold text-charcoal tracking-tight">CERH</span>
        </Link>
      </header>
      <section className="px-6 md:px-12 pb-20 max-w-3xl mx-auto">
        {TERMS_PUBLISHED ? (
          <div data-testid={TERMS_PAGE.content} className="prose prose-slate max-w-none">
            <ReactMarkdown
              remarkPlugins={[remarkGfm]}
              components={{
                h1: ({ children }) => <h1 className="font-heading text-3xl font-bold text-charcoal mb-4">{children}</h1>,
                h2: ({ children }) => <h2 className="font-heading text-xl font-semibold text-charcoal mt-8 mb-3">{children}</h2>,
                p: ({ children }) => <p className="text-sm text-charcoal/75 leading-relaxed mb-3">{children}</p>,
                ul: ({ children }) => <ul className="list-disc pl-5 text-sm text-charcoal/75 space-y-1.5 mb-3">{children}</ul>,
                li: ({ children }) => <li>{children}</li>,
                strong: ({ children }) => <strong className="font-semibold text-charcoal">{children}</strong>,
                hr: () => <hr className="my-8 border-petroleum/10" />,
                table: ({ children }) => (
                  <div className="overflow-x-auto mb-4">
                    <table className="w-full text-sm border-collapse">{children}</table>
                  </div>
                ),
                thead: ({ children }) => <thead className="bg-accent text-charcoal">{children}</thead>,
                th: ({ children }) => <th className="text-left font-semibold px-3 py-2 border-b border-petroleum/15">{children}</th>,
                td: ({ children }) => <td className="px-3 py-2 border-b border-petroleum/10 text-charcoal/75">{children}</td>,
              }}
            >
              {TERMS_CONTENT}
            </ReactMarkdown>
          </div>
        ) : (
          <div data-testid={TERMS_PAGE.unpublishedNotice} className="bg-card border border-petroleum/10 rounded-2xl p-8 text-center mt-6">
            <FileClock className="w-8 h-8 text-petroleum/60 mx-auto mb-3" strokeWidth={1.5} />
            <h1 className="font-heading text-2xl font-bold text-charcoal mb-2">Términos de Uso — en preparación</h1>
            <p className="text-sm text-charcoal/60 max-w-md mx-auto">
              Estamos terminando de revisar este documento con nuestro asesor legal. Estará disponible aquí en breve.
            </p>
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
}
